/** @type {import('../help-index.js').HelpSidebarItem} */
export const FIN_CHE_MANAGEMENT_ITEM = {
  id: 'checks_sidebar_1',
  screenId: 'fin-che-management',
  label: 'Gestión',
  description: 'Cheques emitidos y su estado.',
  detail: {
    sections: [
      {
        title: 'Para qué sirve',
        intro:
          'Consultás y gestionás los cheques propios que emitiste para pagar proveedores: emitidos, aceptados, pagados, cobrados por ventanilla o rechazados.',
      },
      {
        title: 'De dónde salen los cheques',
        paragraphs: [
          'Los cheques se emiten al registrar un pago (Finanzas → Pagos) con medio «cheque propio»: elegís chequera, número, fechas, ID de cheque electrónico (si aplica) y observaciones.',
          'Antes conviene tener chequeras cargadas en Finanzas → Cheques Emitidos → Chequeras.',
        ],
      },
      {
        title: 'Paso 1 — Filtros y búsqueda',
        intro: 'Al entrar ves cheques en estado «Emitido». Podés refinar con:',
        fields: [
          { label: 'Fechas de emisión / de pago', description: 'Rango desde–hasta.' },
          { label: 'Estado', description: 'Emitido, aceptado, pagado, rechazado, cobrado por ventanilla, etc., o «Todos».' },
          { label: 'Chequera', description: 'Filtrá por una chequera o dejá «Todas».' },
          { label: 'Más filtros', description: 'Número de cheque y proveedor (buscador por nombre).' },
        ],
        paragraphs: ['Tocá «Buscar». Podés exportar la grilla.'],
      },
      {
        title: 'Paso 2 — Leer la lista',
        bullets: [
          'Columnas: Número, Monto, Proveedor, Banco emisor, Chequera, Fecha emisión, Fecha pago, Observaciones.',
          'Tras buscar con filtro de estado también ves la columna Estado.',
          'Tocá una fila para ver el detalle del cheque.',
        ],
      },
      {
        title: 'Paso 3 — Acciones',
        bullets: [
          'Cobrar por ventanilla — el proveedor cobró el cheque en ventanilla; registrás caja y fecha. Genera movimiento en caja.',
          'Rechazado — fecha y motivo de rechazo cuando el banco o el beneficiario lo devolvió.',
          'Eliminar — quita el cheque borrando la línea del comprobante de pago asociado (solo si corresponde).',
        ],
      },
    ],
  },
}
